import styled, { css } from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { FlexType } from '@sdk/components/ui/spacing/FlexCss';

export const WrapTextCss = css`
  word-break: break-all;
  white-space: pre-wrap;
`;

type BannerPaddingAndBackgroundProps = {
  themeColor: ThemeColorType;
};
const BannerPaddingAndBackgroundCss = css<BannerPaddingAndBackgroundProps>`
  min-height: 56px;
  padding: 8px 20px 8px 20px;
  background-color: ${({ theme, themeColor }) => theme.colors[themeColor]};
`;

export const BannerContainer = styled.div<BannerPaddingAndBackgroundProps>`
  ${BannerPaddingAndBackgroundCss}
  ${WrapTextCss}
`;

export const BannerWithIconContainer = styled(Row)<BannerPaddingAndBackgroundProps & FlexType>`
  ${BannerPaddingAndBackgroundCss}
  ${WrapTextCss}
`;

export const Hoverable = styled.div`
  opacity: 0.65;

  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`;
